export const useReport = () => {
  const encodeReportID = (id, companyId = null) => {
    const encodeStr = companyId ? `${id}:company-${companyId}` : `${id}:report-id`;

    return btoa(btoa(encodeStr));
  };

  const decodeReportHash = (hash) => {
    let reportID = 'number' === typeof hash ? hash : null;
    let companyID = null;
    let decodeStr = 'number' === typeof hash ? null : atob(atob(hash));
    let replaceStr = ':report-id';

    if (decodeStr) {
      if (decodeStr.includes(':company-')) {
        replaceStr = decodeStr.slice(decodeStr.indexOf(':'));

        companyID = parseInt(decodeStr.slice(decodeStr.indexOf('-') + 1));
      }

      reportID = parseInt(decodeStr.replace(replaceStr, ''));
    }

    return {
      reportID: reportID,
      companyID: companyID,
    };
  };

  return {
    encodeReportID,
    decodeReportHash,
  };
};
